<template>
  <div class="pb-5">
    <v-app class="container">
      <div v-if="routerName != 'ForgotPassword'">
        <div v-if="routerName != 'Login'">
          <Topbar v-if="routerName != 'Register'" />
        </div>
      </div>

      <router-view />
    </v-app>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "App",
  components: {
    Topbar: () => import("@/components/app/Topbar/index.vue"),
  },
  data() {
    return {
      tokenExpire: localStorage.getItem("tokenExpire"),
    };
  },
  computed: {
    routerName() {
      return this.$route.name;
    },
  },
  created() {
    if (this.tokenExpire) {
      if (moment(this.tokenExpire).isBefore(moment())) {
        localStorage.clear();
        this.$router.push("/login");
      }
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/app.scss";
</style>
